import { sectionNames } from "@dashboard/intl";
import { parse as parseQs } from "qs";
import { FC } from "react";
import { useIntl } from "react-intl";
import { Route, RouteComponentProps, Switch } from "react-router-dom";

import { WindowTitle } from "../components/WindowTitle";
import {
  cartVisibilityDetailPath,
  cartVisibilityListPath,
  CartVisibilityListUrlQueryParams,
} from "./urls";
import { CartVisibilityDetailsView } from "./views/CartVisibilityDetailsView";
import { CartVisibilityListView } from "./views/CartVisibilityListView";

const CartVisibilityList: FC<RouteComponentProps> = ({ location }) => {
  const qs = parseQs(location.search.substr(1)) as any;
  const params: CartVisibilityListUrlQueryParams = qs;

  return <CartVisibilityListView params={params} />;
};

const CartVisibilityDetails: FC<RouteComponentProps<{ id: string }>> = ({ match }) => (
  <CartVisibilityDetailsView id={decodeURIComponent(match.params.id)} />
);

const CartVisibilitySection: FC = () => {
  const intl = useIntl();

  return (
    <>
      <WindowTitle title={intl.formatMessage(sectionNames.liveCarts)} />
      <Switch>
        <Route exact path={cartVisibilityListPath} component={CartVisibilityList} />
        <Route exact path={cartVisibilityDetailPath(":id")} component={CartVisibilityDetails} />
      </Switch>
    </>
  );
};

export default CartVisibilitySection;
